import React from "react";
import { List, Flex, Text } from "@fluentui/react-northstar";
import { observer } from "mobx-react-lite";
import CallIconAvatar from "../../atoms/CallIconAvatar";
import Constants from "../../../constants/text-constants";
import PropTypes from "prop-types";
import LocationListItem from "../LocationListItem";

const SettingsLocationList = observer((props) => {
  const { locations, onEditClicked, onDeleteLocationClick } = props;
  const allListItems = locations.map((location) => {
    return {
      key: location.code,

      content: (
        <LocationListItem
          location={location}
          testId={"locationListItem" + location.code}
          onEditClicked={onEditClicked}
          onDeleteClicked={onDeleteLocationClick}
        />
      ),
      media: {
        as: CallIconAvatar,
      },
    };
  });

  return locations.length > 0 ? (
    <Flex
      className="settings-locations-list-flex"
      data-testid="settingsLocationList"
    >
      <List
        selectable
        selectedIndex={-1}
        items={allListItems}
        truncateContent={true}
      />
    </Flex>
  ) : (
    <Flex
      className="settings-locations-list-flex"
      hAlign="center"
      vAlign="center"
      column
      data-testid="settingsLocationListNoLocations"
    >
      <Text disabled size="medium">
        {Constants.LOCATION_LINE_ONE}
      </Text>
      <Text disabled size="medium">
        {Constants.LOCATION_LINE_TWO}
      </Text>
    </Flex>
  );
});

SettingsLocationList.propTypes = {
  locations: PropTypes.array,
};

SettingsLocationList.defaultProps = {
  locations: [],
};

export default SettingsLocationList;
